import { Tables } from '@/types/database.types';
import { CustomMutationOptions, CustomQueryOptions } from '@/types/query';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createLLMApiKey, deleteLLMApiKey, getLLMApiKeys } from '.';
import {
  CreateLLMApiKeyParams,
  CreateLLMApiKeyResponse,
  DeleteLLMApiKeyParams,
  GetLLMApiKeysParams,
} from './type';

const keyname = 'llm_api_key';
export const useGetLLMApiKeys = (
  params: GetLLMApiKeysParams = {},
  option?: CustomQueryOptions<Tables<'llm_api_key'>[]>
) => {
  return useQuery({
    queryKey: [keyname, params],
    queryFn: async () => getLLMApiKeys(params),
    ...option,
  });
};

export const useCreateLLMApiKey = (
  options?: CustomMutationOptions<
    CreateLLMApiKeyParams,
    CreateLLMApiKeyResponse
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn: createLLMApiKey,
    onSuccess: async (data, variables, context) => {
      await options?.onSuccess?.(data, variables, context);
      await queryClient.invalidateQueries({
        queryKey: [keyname],
      });
    },
  });
};

export const useDeleteLLMApiKey = (
  options?: CustomMutationOptions<DeleteLLMApiKeyParams>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn: deleteLLMApiKey,
    onSuccess: async (data, variables, context) => {
      await options?.onSuccess?.(data, variables, context);
      await queryClient.invalidateQueries({
        queryKey: [keyname],
      });
    },
  });
};
